import { Checkbox, Heading, Stack, Text } from 'braid-design-system';

import type { UserRegistrationType } from 'src/types/userRegistrationType';

interface EmailOptInProps {
  userRegistrationType: UserRegistrationType;
  valid: boolean;
  errorMessage: string;
  onChange: (value: boolean) => void;
  value: boolean;
}

export const EmailOptIn = (props: EmailOptInProps) => (
  <Stack space="large">
    <Stack space="small">
      <Heading level="3" component="h2">
        Communication preferences
      </Heading>
      <Text>
        Receive personalised buying/selling tips, product recommendations and
        marketplace insights. Unsubscribe at any time.
      </Text>
    </Stack>
    <Checkbox
      id="email-opt-in"
      data={{ testid: 'email-opt-in-checkbox' }}
      checked={props.value}
      onChange={(event) => props.onChange(event.currentTarget.checked)}
      label="Yes, I agree to receive communications from SEEK Business"
      tone={props.valid ? 'neutral' : 'critical'}
      message={!props.valid && props.errorMessage}
    />
  </Stack>
);
